import { Store } from 'lucide-react';
import { BRANDS } from '../../data/brandNotes';

export default function BrandFitNotes({ t, selectedBrand, onBrandChange }) {
  const brand = BRANDS.find((b) => b.id === selectedBrand) || BRANDS[0];

  return (
    <div className="rounded-xl border border-slate-700 bg-slate-900/50 p-4">
      <div className="flex items-center gap-2 mb-3">
        <Store className="w-4 h-4 text-emerald-400" />
        <label htmlFor="brand-select" className="text-sm font-medium text-slate-300">
          {t.brandNotes.title}
        </label>
      </div>
      <select
        id="brand-select"
        value={selectedBrand}
        onChange={(e) => onBrandChange(e.target.value)}
        className="w-full rounded-lg border border-slate-600 bg-slate-800 px-3 py-2.5 text-sm text-white focus:border-emerald-500 focus:outline-none"
      >
        {BRANDS.map((b) => (
          <option key={b.id} value={b.id}>
            {b.name}
          </option>
        ))}
      </select>
      <p className="mt-3 text-xs text-slate-400 leading-relaxed border-l-2 border-amber-500/50 pl-3">
        {brand.tip}
      </p>
    </div>
  );
}
